import { createSlice } from "@reduxjs/toolkit";
import { getUserDetails } from "./actions";

const initialState = {
  userData: null,
  loading: false,
  error: null,
};
const getUserDetailSlice = createSlice({
  name: "getUserDetails",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
      builder
      .addCase(getUserDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getUserDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.userData = action.payload;
      })
      .addCase(getUserDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});
export default getUserDetailSlice.reducer;
